import { render, staticRenderFns } from "./monaco.vue?vue&type=template&id=f155c83a&scoped=true&"
import script from "./monaco.vue?vue&type=script&lang=js&"
export * from "./monaco.vue?vue&type=script&lang=js&"
import style0 from "./monaco.vue?vue&type=style&index=0&id=f155c83a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f155c83a",
  null
  
)

export default component.exports